import * as filestatusList from './filestatusList';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    filestatusList: filestatusList.IState
}

export const ActionCreators = {
    filestatusList: filestatusList.ActionCreators
}

export const Reducers = combineReducers<IState>({
    filestatusList: filestatusList.Reducers
});

export function* sagas() {
    yield all([
        fork(filestatusList.sagas)
    ]);
}
